export const Rights = [
    "WEB_MODULE_PILOT_BOAT_PILOTAGES_READ"
]
